import authGraphQLRequest from "utils/authGraphQLRequest";

export const getProfile = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `{
  user{
    id
    email
    first_name
    last_name
    role_id
    role
    created_at
    updated_at
    last_sign_in_at
    organizations
    auth_2fa

  }
}
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_user'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getProfileSecond = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `{
  userSecond{
    id
    email
    first_name
    last_name
    role_id
    role
    created_at
    updated_at
    last_sign_in_at
    organizations
    auth_2fa

  }
}
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_user_second'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAllUsers = ({ page, per_page, searchTexts }: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `{
    allUsers(page: ${page}, per_page: ${per_page} ${searchTexts ? `, searchTexts: "${searchTexts}"` : ''}){
      users{
        id
        email
        first_name
        last_name
        role_id
        role
        created_at
        updated_at
        last_sign_in_at
        organizations
        auth_2fa
        }
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_user'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAllUsersList = ({ page, per_page, searchTexts }: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `{
    allUsersList(page: ${page}, per_page: ${per_page} ${searchTexts ? `, searchTexts: "${searchTexts}"` : ''}){
      users{
        id
        email
        first_name
        last_name
        role_id
        role
        created_at
        updated_at
        last_sign_in_at
        organizations
        auth_2fa
        }
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_user_all_list'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAllUsersData = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `{
    allUsers{
      users{
        id
        email
        first_name
        last_name
        role_id
        role
        created_at
        updated_at
        last_sign_in_at
        organizations
        auth_2fa
        }
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_user'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createUser = (data: any): Promise<any> => {
  let {email,first_name,last_name,role_id,organizations,password} = data;

  const formattedOrganizations : any = organizations.length > 0
    ? `[${organizations.map((org: string) => `"${org}"`).join(", ")}]`
    : "[]";

  return new Promise((resolve, reject) => {
    let queryString = `
    mutation {
      createUser (
         email: "${email}",
         first_name: "${first_name}",
         last_name : "${last_name}",
         role_id : "${role_id}",
         organizations : ${formattedOrganizations},
         password : "${password}",
      ) {
         user {
          email
          first_name
          last_name
          role_id
          created_at
          organizations
        }
        status
        message
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_create_user'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateUser = (data: any,id:any): Promise<any> => {
  let {email,first_name,last_name,role_id,organizations,password} = data;

  const formattedOrganizations : any = organizations.length > 0
    ? `[${organizations.map((org: string) => `"${org}"`).join(", ")}]`
    : "[]";

  return new Promise((resolve, reject) => {
    let queryString = `
    mutation {
      updateUser (
        user_id : "${id}",
         email: "${email}",
         first_name: "${first_name}",
         last_name : "${last_name}",
         role_id : "${role_id}",
         organizations : ${formattedOrganizations},
         ${password ? `, password: "${password}"` : ""}
      ) {
         user {
          email
          first_name
          last_name
          updated_at
          organizations
        }
        status
        message
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_update_user'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteUser = (id:any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `
    mutation {
      deleteUser(id: "${id}") {
        status
        message
      }
    }
      `;
        authGraphQLRequest<any>(
          queryString,
          '/api/v1/graphql_delete_user'
        )
          .then((responseData) => {
            resolve(responseData);
          })
          .catch((err) => {
            reject(err);
          });
  }); 
}

export const updateProfile = (data: any): Promise<any> => {
  let {email,first_name,last_name} = data;
  return new Promise((resolve, reject) => {
    let queryString = `
    mutation {
      updateProfile (
         email: "${email}",
         first_name: "${first_name}",
         last_name : "${last_name}",
      ) {
         user {
          email
          first_name
          last_name
        }
        status
        message
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_update_profile'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updatePassword = (data: any): Promise<any> => {
  let {old_password,new_password} = data;
  return new Promise((resolve, reject) => {
    let queryString = `
    mutation {
      updateUserPassword (
         old_password: "${old_password}",
         new_password: "${new_password}"
      ) {
         user {
          email
          first_name
          last_name
        }
        status
        message
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_update_passward'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteProfile = (data: any): Promise<any> => {
  let {password} = data;
  return new Promise((resolve, reject) => {
    let queryString = `
    mutation {
      deleteUserProfile (
         password: "${password}"
      ) {
        status
        message
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_delete_profile'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const get2FAData = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `
    {
      authDetails {
        status
        base64_image
        secret_key
        recover_key
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_auth_details'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const get2FTAuth = (data:any): Promise<any> => {
  let {enable_2FA , user_id , secret_key , recover_key , inside_flag} = data;
  return new Promise((resolve, reject) => {
    let queryString = `
    mutation {
      manage2fa(input: {
        user_id: "${user_id}",
        enable_2FA: ${enable_2FA}
        ${secret_key ? `, secret_key: "${secret_key}"` : ""}
        ${recover_key ? `, recover_key: "${recover_key}"` : ""}
        ${inside_flag ? `, inside_flag: "${inside_flag}"` : ""}
      }) {
        status
        message
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_manage_2FA'
    )
      .then((responseData) => {
          resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const get2FTAuthVerify = (data: any): Promise<any> => {
  const { otp, user_id, secret_key, recover_key, inside_flag } = data;

  const variables: any = {
    userId: user_id,
    otp,
  };
  if (inside_flag !== undefined) variables.insideFlag = inside_flag;
  if (secret_key) variables.secretKey = secret_key;
  if (recover_key) variables.recoverKey = recover_key;

  return new Promise((resolve, reject) => {
    const queryString = `
    mutation verifyOtpFront(
      $userId: String!, 
      $otp: String!
      ${inside_flag !== undefined ? `, $insideFlag: Boolean` : ""}
      ${secret_key ? `, $secretKey: String` : ""}
      ${recover_key ? `, $recoverKey: String` : ""}
    ) {
      verifyOtpFront(
        user_id: $userId, 
        otp: $otp
        ${inside_flag !== undefined ? `, inside_flag: $insideFlag` : ""}
        ${secret_key ? `, secret_key: $secretKey` : ""}
        ${recover_key ? `, recover_key: $recoverKey` : ""}
      ) {
        status
        message
        auth_token
        user
      }
    }
    `;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_verify_otp_front',
      variables
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
